import { render, staticRenderFns } from "./OrgProfileAdd.vue?vue&type=template&id=5bb9d271"
import script from "./OrgProfileAdd.vue?vue&type=script&lang=js"
export * from "./OrgProfileAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports